<template>
  <div class="personal-form">
    <div class="isExam" v-if="isExam">审核通过</div>  
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
    <a-row type="flex" justify="space-around">
        <a-col :span="12">
            <a-form-model-item ref="enterpriseName" label="企业名称" prop="enterpriseName">
                <a-input :disabled="isExam" v-model="form.enterpriseName"/>
            </a-form-model-item>
        </a-col>
        <a-col :span="12">
            <a-form-model-item ref="creditCode" label="统一社会信用代码" prop="creditCode">
                <a-input :disabled="isExam" v-model="form.creditCode"/>
            </a-form-model-item>
        </a-col>
    </a-row>
    <a-row type="flex" justify="space-around">
        <a-col :span="12">
            <a-form-model-item ref="legalPerson" label="法定代表人" prop="legalPerson">
                <a-input :disabled="isExam" v-model="form.legalPerson"/>
            </a-form-model-item>
        </a-col>
        <a-col :span="12">
            <a-form-model-item ref="legalPhone" label="法定代表人手机号" prop="legalPhone">
                <a-input :disabled="isExam" v-model="form.legalPhone"/>
            </a-form-model-item>
        </a-col>
    </a-row>
    <a-row type="flex">
        <a-col :span="24">
            <a-form-model-item ref="enterpriseAddress"  :label-col="{ span:4}" :wrapper-col="{ span: 20 }" label="企业地址" prop="enterpriseAddress">
                <a-input :disabled="isExam" v-model="form.enterpriseAddress"/>
            </a-form-model-item>
        </a-col>
    </a-row>
    <a-row type="flex" justify="space-around">
        <a-col :span="8">
            <a-form-model-item :label-col="{ span:12 }" :wrapper-col="{ span: 12 }" ref="licenseName" label="营业执照" prop="licenseName">
                 <upload :disabled="isExam" @getFile="getFile" @changeImg="changeImg" :imageUrl="img1" :id=1 ref="uploadyy"></upload>
            </a-form-model-item>
        </a-col>
        <a-col :span="8">
            <a-form-model-item :label-col="{ span:12 }" :wrapper-col="{ span: 12 }" ref="card1Name"  label="法人身份证正面" prop="card1Name">
                 <upload :disabled="isExam" @getFile="getFile" @changeImg="changeImg" :imageUrl="img2" :id=2 ref="uploadyy"></upload>
            </a-form-model-item>
        </a-col>
        <a-col :span="8">
            <a-form-model-item :label-col="{ span:12 }" :wrapper-col="{ span: 12 }" ref="card2Name" label="法人身份证反面" prop="card2Name">
                 <upload :disabled="isExam" @getFile="getFile" @changeImg="changeImg" :imageUrl="img3" :id=3 ref="uploadyy"></upload>
            </a-form-model-item>
        </a-col>
    </a-row>
    <a-row>
       <a-col :span="24" style="padding-left:160px;padding-bottom:30px;">  
        温馨提示：上传图片为jpeg，png或jpg格式，且上传图片大小不能超过2MB！
       </a-col> 
    </a-row>    
     <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" v-if="!isExam">
        <a-button type="primary" @click="onSubmit"> 提交 </a-button>
        <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import upload from '../../components/upload.vue'
export default {
  components:{
      upload
  },
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      form: {
        enterpriseName:'',//企业名称", 
        creditCode:'',//"统一社会信用代码", 
        legalPerson:'',//"法定代表人",
        legalPhone:'',//"法定代表人手机号", 
        enterpriseAddress:'',//"企业地址", 
        licenseName:'',//"营业执照附件名称",
        licenseUrl:'',//"营业执照附件url",
        card1Name:'',//"法人身份证正面附件名称", 
        card1Url:'',//"法人身份证正面附件url", 
        card2Name:'',//"法人身份证反面附件名称",
        card2Url:'',//"法人身份证反面附件url"
      },
      img1:"",
      img2:"",
      img3:"",
      isExam:false,
      rules: {
        enterpriseName: [
            {
                required: true,
                message: "请输入企业名称",
                trigger: "blur",
            }
        ],
        creditCode:[
            {
                required: true,
                message: "请输入统一社会信用代码",
                trigger: "blur", 
            },
            {
                pattern: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,
                message: '统一社会信用代码有误',
                trigger: "blur", 
            }
        ],
        legalPerson:[
            {
                required: true,
                message: "请输入法定代表人",
                trigger: "blur", 
            }
        ],
        legalPhone:[
            {
                required: true,
                message: "请输入法定代表人手机号",
                trigger: "blur", 
            },
            {
                pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                message: '请输入正确的手机号',
                trigger: "blur", 
            }
        ],
        enterpriseAddress:[
            {
                required: true,
                message: "请输入企业地址",
                trigger: "blur", 
            }
        ],
        licenseName:[
            {
                required: true,
                message: "请上传营业执照附件",
                trigger: "blur", 
            }
        ],
        card1Name:[
            {
                required: true,
                message: "请上传法人身份证正面",
                trigger: "blur", 
            }
        ],
        card2Name:[
            {
                required: true,
                message: "请上传法人身份证反面",
                trigger: "blur", 
            }
        ]
      },
    };
  },
  mounted(){
      this.lookForData();
  },
  methods: {
    lookForData(){
        this.$https.get('/portal/certifi/getEnterpriseByUser',this.form).then(res=>{
            if(res.code == 200){
                this.form = res.data;
                this.isExam = this.form.status == '1'?true:false
                this.img1 = res.data.licenseUrl;
                this.img2 = res.data.card1Url;
                this.img3 = res.data.card2Url;
            }
        })
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$https.post('/portal/certifi/addEnterpriseCertifi',this.form).then(res=>{
                 if(res.code == 200){
                    this.img1 = this.form.licenseUrl;
                    this.img2 = this.form.card1Url;
                    this.img3 = this.form.card2Url;
                     this.lookForData();
                     this.$message.success('保存成功');
                 }else{
                     this.$message.error(res.msg);
                 }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getFile(info,id){
        console.log(info.file);
        if(id == 1){
            this.form.licenseName = info.file.response.data.name;
            this.form.licenseUrl = info.file.response.data.url;
            this.img1 = info.file.response.data.url;
        }else if(id==2){
            this.form.card1Name = info.file.response.data.name;
            this.form.card1Url = info.file.response.data.url;
            this.img2 = info.file.response.data.url;
        }else{
            this.form.card2Name = info.file.response.data.name;
            this.form.card2Url = info.file.response.data.url;
            this.img3 = info.file.response.data.url;
        }
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.img1 = '';
      this.img2 = '';
      this.img3 = '';
    },
    changeImg(img,id){
        console.log(img,id)
         if(id == 1){
             this.img1 = img;
         }else if(id == 2){
             this.img2 = img;
         }else{
             this.img3 = img;
         }
    }
  },
};
</script>

<style lang="less" scoped>
.personal-form{
    background: #fff;
    padding:0 20px;
}
.isExam{
    line-height: 30px;
    padding:0 0  20px 210px;
}
</style>